<section class="wrapper" style="max-width: 1785px;" >
<!-- ********************Header *************************************************-->
  <div  class="styled-input" style="width: 1700px;height: 50px; background-color: rgb(187, 187, 255);border-style: groove;border-color:rgb(199, 219, 250) ;border-radius: 2%;left: 3%;display: flex; justify-content: space-between; align-items: center;">
    <div >
    <label style="width: 15%;font-size: large;text-decoration: underline;">Patient ID:</label>
    <input type="teaxt" name="ID" required style="width: 7%;border-style: none;font-size: large;"  [(ngModel)]="Patientcode" (change)="Retrive_All()">
    <label  style="width: 5%;">       </label>
    <span class="fa fa-search"  style="cursor: grab;font-size: 150%;" aria-hidden="true" (click)="OpenPatientDialog()"></span>
    <label  style="width: 5%;">       </label>
    <label style="width: 9%;font-size: large;text-decoration: underline;">Patient Name:</label>
    <input type="teaxt" name="Name" required style="width: 13%;border-style: none;background-color:  rgb(187, 203, 238);font-size: large;"[(ngModel)]="Patientname">
    <label style="width: 5%;"></label>

    <label style="width: 5%;font-size: large;text-decoration: underline;">Age :</label>
    <input type="text" name="age" placeholder="0" required disabled style="width: 2%;background-color:  rgb(187, 203, 238);font-size: larger;border-style: none;" [(ngModel)]="paAge">
    <label>Year</label>
    <label style="width: 2%;">      </label>

    <label style="width: 6%;font-size: large;text-decoration: underline;">Gender: </label>
    <input type="text" name="Gender" required disabled style="width: 4%;background-color: rgb(187, 203, 238);border-style: none;font-size: larger;" [(ngModel)]="gender">
    <label style="width: 2%;">      </label>
    <label style="width: 15%;font-size: large;text-decoration: underline;">Date of First Visit: </label>
    <input type="date" name="dateEntry1" required style="width: 8%;border-style: none;background-color:  rgb(187, 203, 238);font-size: large;"[(ngModel)]="dateEntry1">
    <label style="width: 5%;">      </label>
    <label style="width: 8%;font-size: large;text-decoration: underline;">Cancer Type :</label>
    <select id="CancerType" name="CancerType" style="width: 15%;background-color:  rgb(187, 203, 238);border-style: none;font-size: larger;"  required="" [(ngModel)]="cancerID" [value]="cancerID">
    <option value="{{Canc.cancerID}}" *ngFor="let Canc of cancerlist; let i = index">{{Canc.cancerName}}
      <button  style="width: 6%;"class="fa fa-medkit"></button>
    </option>
  </select>
  <a   href="PreparationOrder" target="_blank"  (click)="OpenPreparation()"  style="cursor: grab;" >
  <button type="button" class="add-boutton fa fa-medkit" style="left: 93%;width: 3%;background-color: rgb(0, 12, 101);gap: 30px; color: rgb(255, 255, 255);border-radius: 25%;  font-weight: normal;" matTooltip="clinical pharmacy" name="Addfont" ></button>
</a>
</div>

</div>
</section>
<!-- End Header -->
<section >
  <div class="top-section" >
        <div class="widget left" style="position: absolute;height: 30%;" >
          <app-diganostic></app-diganostic>

        </div>
        <div class="widget meiddel" style=" position: absolute;height: 37.5%;left: 27%;">
          <app-anti-cancer-treatment></app-anti-cancer-treatment>
        </div>
        <div class="widget right" style="position: absolute;height: 27%;left: 72%;">
          <app-nursing-assessment></app-nursing-assessment>
        </div>
  </div>

  <div class="scound-section">
          <div class="widget left" style="position: absolute;top: 60%;height: 27%;">
            <app-progress-note></app-progress-note>
          </div>
          <div class="widget meiddel" style="position: absolute;height: 40%;top: 67%;left: 27%;">
            <app-decision></app-decision>
          </div>
          <div class="widget right" style="position: absolute;left: 72%;top: 60%;height: 50%;">
            <app-medical-history-v></app-medical-history-v>
          </div>
  </div>

<div class="scound-section">
  <div class="widget left" style="position: absolute;top: 88%;height: 200px;">
    <app-clinical-exam></app-clinical-exam>

  </div>
  <!-- <div class="widget meiddel" style="position: absolute;left: 480px;top: 690px;height: 200px;">
    <app-event-during-ttt></app-event-during-ttt>
  </div> -->
  <!-- <div class="widget right" style="position: absolute;left: 1295px;height: 200px;top: 690px;">
    <app-toxicity></app-toxicity>
  </div> -->
</div>

<div>

</div>
<div>

</div>
</section>
<br>
<section>
<div  style="position: absolute;top: 920px;width: 1750px;text-align: center;font-weight: bold;">
  <a href="PatientDocumentNew" target="_blank">
    <button type="button" class="theme-button btn" (click)="PutPatient()" style="background-color: rgb(0, 0, 61);color: white;width: 15%;border-style: none;" name="submit">Patient Documents</button>
  </a>
  <a href="annex" target="_blank">
    <button type="button" class="theme-button btn" style="background-color: rgb(1, 48, 28);color: white;width: 15%;border-style: none;" name="Delete">Annex</button>
  </a>
    <a href="PatientReservation" class="drop-text">
  <button type="button" class="theme-button btn" style="background-color: rgb(158, 0, 0);color: white;width: 15%;border-style: none;"name="rep" name="rep">Exit</button>
    </a>
</div>
</section>
